export default {"src":"/_next/static/media/bracketIcon.59f439f6.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};